import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isHeyJivuNativeApp } from '../../constants/runtime.constants';
import { defaultAuthenticatedRoute } from '../utils/auth-routing.util';
import { restoreAuthSession } from '../utils/auth-session.util';
import { AuthStore } from '../state/auth.store';

export const nativeRootRedirectGuard: CanMatchFn = () => {
  if (environment.nativeApp !== true && !isHeyJivuNativeApp()) {
    return false;
  }

  const authStore = inject(AuthStore);
  const router = inject(Router);

  return restoreAuthSession(authStore).pipe(
    map(() => {
      const target = authStore.isAuthenticated()
        ? defaultAuthenticatedRoute(authStore.user())
        : '/login';
      return router.createUrlTree([target]);
    })
  );
};
